
const InsuranceVarian = () => {
    return (
        <>
            <div className="varian_container">
                <h2>Varian Asuransi <span className="orange_text">ChiFlo</span></h2>

                <div className="listInsurance">
                    <div className="insurance greenBg" >
                        <h4>Kebakaran</h4>

                        <p>Memberikan jaminan pada properti atas resiko , dengan perluasan jaminan seperti banjir atau water damage, kerusuhan, huru-hara, dan jaminan lainnya. Jaminan ini disebut juga Property All Risk.</p>
                    </div>

                    <div className="insurance orangeBg" >
                        <h4>All Risk</h4>

                        <p>Memberikan jaminan pada properti atas resiko , dengan perluasan jaminan seperti banjir atau water damage, kerusuhan, huru-hara, dan jaminan lainnya. Jaminan ini disebut juga Property All Risk.</p>
                    </div>

                    <div className="insurance greenBg" >
                        <h4>Gempa</h4>

                        <p>Memberikan jaminan pada properti atas resiko , dengan perluasan jaminan seperti banjir atau water damage, kerusuhan, huru-hara, dan jaminan lainnya. Jaminan ini disebut juga Property All Risk.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InsuranceVarian;